//
// Copyright (c) 2011-2019 by Curalate, Inc.
//
import { PojoSet } from 'pojo-sets';

import { IToastNotification } from '@legacy-components/common/toast-notifications/toastNotificationsModel';

export interface IConditionalFinalToast {
  toast: IToastNotification;
  requiredFlags: FULLSCREEN_WORKFLOW_FLAGS[];
}

export interface IFullScreenWorkflowState {
  inWorkflow: PojoSet<FULLSCREEN_WORKFLOW_NAMES>;
  flags: PojoSet<FULLSCREEN_WORKFLOW_FLAGS>;
  conditionalFinalToasts: IConditionalFinalToast[];
}

export enum FULLSCREEN_WORKFLOW_ACTIONS {
  START_WORKFLOW = 'FULLSCREEN_WORKFLOW_ACTIONS/START_WORKFLOW',
  STOP_WORKFLOW = 'FULLSCREEN_WORKFLOW_ACTIONS/STOP_WORKFLOW',
  ADD_CONDITIONAL_FINAL_TOAST = 'FULLSCREEN_WORKFLOW/ADD_CONDITIONAL_FINAL_TOAST',
  SET_FLAG = 'FULLSCREEN_WORKFLOW/SET_FLAG',
  RESET_STATE = 'FULLSCREEN_WORKFLOW/RESET_STATE',
}

export enum FULLSCREEN_WORKFLOW_NAMES {
  ADD_TO_GALLERIES = 'FULLSCREEN_WORKFLOW_NAMES/ADD_TO_GALLERIES',
  REQUEST_RIGHTS_AT_MENTIONED = 'FULLSCREEN_WORKFLOW_NAMES/REQUEST_RIGHTS_AT_MENTIONED',
  REQUEST_RIGHTS_NON_AT_MENTIONED = 'FULLSCREEN_WORKFLOW_NAMES/REQUEST_RIGHTS_NON_AT_MENTIONED',
}

export enum FULLSCREEN_WORKFLOW_FLAGS {
  ADDED_TO_GALLERIES = 'FULLSCREEN_WORKFLOW_FLAGS/ADDED_TO_GALLERIES',
  RIGHTS_REQUESTED = 'FULLSCREEN_WORKFLOW_FLAGS/RIGHTS_REQUESTED',
}
